const registry = new Map();

export const addEl = (id, ref) => registry.set(id, ref);
export const getEl = (id) => registry.get(id);
export const deleteEl = (id) => registry.delete(id);
export const hasEl = (id) => registry.has(id);

window.reg = registry;
